var render, staticRenderFns
import script from "./Gauge.vue?vue&type=script&lang=js&"
export * from "./Gauge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/taylor-minhasvendas-frontend-teste/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('182320e1')) {
      api.createRecord('182320e1', component.options)
    } else {
      api.reload('182320e1', component.options)
    }
    
  }
}
component.options.__file = "src/core/components/charts/Gauge.vue"
export default component.exports